function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M22 9v6h-1c-3 0-4 1-4 4v1.5H7V19c0-3-1-4-4-4H2V9h1c3 0 4-1 4-4V3.5h10V5c0 3 1 4 4 4h1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 15a3 3 0 100-6 3 3 0 000 6zM7 3.5V5c0 3-1 4-4 4H2v-.5c0-3.5 2-5 5-5zm15 5V9h-1c-3 0-4-1-4-4V3.5c3 0 5 1.5 5 5zM7 19v1.5c-3 0-5-1.5-5-5V15h1c3 0 4 1 4 4zm15-4v.5c0 3.5-2 5-5 5V19c0-3 1-4 4-4h1z"
})));